<template>
  <div id="app" class="h-100">
    <router-view></router-view>
  </div>
</template>
<script>

export default {
  name: "app",
  data() {
    return {};
  },
  components: {
    
  }
};
</script>
<style>
</style>
